/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import LayoutAppHeader from './components/container/LayoutAppHeader';
import getAllUrlParams from '../../utils/getAllUrlParams';

const LayoutContainer = styled('div')`
  background-color: #f5f5f5;
  overflow-y: ${(props) => (props.overflowVisible ? 'visible' : props.fullWidth ? 'hidden' : 'scroll')};
`;

const MainContent = styled('main')`
  position: relative;
  height: auto;
  height: 100%;
  min-height: 100%;
  padding: ${(props) => (props.fullWidth ? '0px' : '64px 15px 15px 15px')};
  ${(props) => (props.fullWidth && !props.overflowVisible ? (
    'overflow: hidden;'
  ) : '')};
`;

const Layout = ({
  children,
  className,
  fullWidth,
  overflowVisible,
  hideHeader,
  bottomFunction,
}) => {
  // Check URL params for hideNav query parameter
  const urlParams = getAllUrlParams(window.location.href, false);
  const shouldHideHeader = hideHeader || urlParams.hideNav === 'true';
  let scrollRef = null;
  if (bottomFunction) {
    scrollRef = useBottomScrollListener(() => bottomFunction(), { offset: 100 });
  }

  return (
    <LayoutContainer
      className={className}
      fullWidth={fullWidth}
      ref={scrollRef}
      overflowVisible={overflowVisible}
    >
      <LayoutAppHeader hideHeader={shouldHideHeader} />
      <MainContent
        className={fullWidth ? '' : 'container'}
        fullWidth={fullWidth}
        overflowVisible={overflowVisible}
      >
        {children}
      </MainContent>
    </LayoutContainer>
  );
};

Layout.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  overflowVisible: PropTypes.bool,
  hideHeader: PropTypes.bool,
  bottomFunction: PropTypes.func,
};

Layout.defaultProps = {
  className: undefined,
  fullWidth: false,
  hideHeader: undefined,
  bottomFunction: undefined,
  overflowVisible: false,
};

export default Layout;